/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/DocumentDataExtractorConfigurationTypes.yaml
/** @internal */
export var DocumentDataExtractorConfigurationElement;
(function (DocumentDataExtractorConfigurationElement) {
    /** @internal */
    function from(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'DateValidationConfiguration':
                return new DateValidationConfiguration(source);
            case 'DeAddressParserConfiguration':
                return new DeAddressParserConfiguration(source);
            case 'EuropeanHealthInsuranceCardConfiguration':
                return new EuropeanHealthInsuranceCardConfiguration(source);
            case 'MRZFallbackConfiguration':
                return new MrzFallbackConfiguration(source);
            case 'AutoFocusConfiguration':
                return new AutoFocusConfiguration(source);
            case 'GlareDetectionConfiguration':
                return new GlareDetectionConfiguration(source);
            case 'DocumentDataExtractorCommonConfiguration':
                return new DocumentDataExtractorCommonConfiguration(source);
            default:
                throw new Error(`Unknown child class name: ${_type}`);
        }
    }
    DocumentDataExtractorConfigurationElement.from = from;
})(DocumentDataExtractorConfigurationElement || (DocumentDataExtractorConfigurationElement = {}));
/**
Date validation configuration.
This configuration element does not enable the scanning of any document types by itself.
Add to recognizer configuration to require date validation checks for specific document types.
*/
export class DateValidationConfiguration {
    /** @param source {@displayType `DeepPartial<DateValidationConfiguration>`} */
    constructor(source = {}) {
        this._type = 'DateValidationConfiguration';
        /**
          Minimum year that is considered valid.
          
          Default is 0
          */
        this.minYear = 0;
        /**
          Maximum year that is considered valid.
          
          Default is 2999
          */
        this.maxYear = 2999;
        if (source.minYear !== undefined) {
            this.minYear = source.minYear;
        }
        if (source.maxYear !== undefined) {
            this.maxYear = source.maxYear;
        }
        if (source.fieldTypeName !== undefined) {
            this.fieldTypeName = source.fieldTypeName;
        }
        else {
            throw new Error('fieldTypeName must be present in constructor argument');
        }
    }
}
/**
German Address Field validation configuration.
This configuration does not enable the scanning of any document types by itself.
Add to recognizer configuration to require German Address validation checks for specific document types.
*/
export class DeAddressParserConfiguration {
    /** @param source {@displayType `DeepPartial<DeAddressParserConfiguration>`} */
    constructor(source = {}) {
        this._type = 'DeAddressParserConfiguration';
        /**
          binary file with address database.
          
          Default is ""
          */
        this.binaryFileAddressDatabase = '';
        if (source.documentTypes !== undefined) {
            this.documentTypes = source.documentTypes.map((it) => {
                return it;
            });
        }
        else {
            throw new Error('documentTypes must be present in constructor argument');
        }
        if (source.binaryFileAddressDatabase !== undefined) {
            this.binaryFileAddressDatabase = source.binaryFileAddressDatabase;
        }
    }
}
/** @hidden */
export const EuropeanHealthInsuranceCardIssuingCountryValues = [
    'AUSTRIA',
    'BELGIUM',
    'BULGARIA',
    'CROATIA',
    'CYPRUS',
    'CZECH_REPUBLIC',
    'DENMARK',
    'ESTONIA',
    'FINLAND',
    'FRANCE',
    'GERMANY',
    'GREECE',
    'HUNGARY',
    'IRELAND',
    'ITALY',
    'LATVIA',
    'LITHUANIA',
    'LUXEMBOURG',
    'MALTA',
    'NETHERLANDS',
    'POLAND',
    'PORTUGAL',
    'ROMANIA',
    'SLOVAKIA',
    'SLOVENIA',
    'SPAIN',
    'SWEDEN',
    'SWITZERLAND',
];
/**
European Health Insurance Card (EHIC) configuration element. Add to extractor configuration to scan EHICs.
*/
export class EuropeanHealthInsuranceCardConfiguration {
    /** @param source {@displayType `DeepPartial<EuropeanHealthInsuranceCardConfiguration>`} */
    constructor(source = {}) {
        this._type = 'EuropeanHealthInsuranceCardConfiguration';
        /**
          If an expected country is selected, validation rules for the given country are used,
          and if the expected country cannot be inferred or the inferred country doesn't  match the given country,
          the result of extract() will be IncompleteValidation.
          */
        this.expectedCountry = null;
        if (source.expectedCountry !== undefined) {
            this.expectedCountry =
                source.expectedCountry != null
                    ? EuropeanHealthInsuranceCardIssuingCountryValues.includes(source.expectedCountry)
                        ? source.expectedCountry
                        : null
                    : null;
        }
    }
}
/**
MRZ fallback configuration element.
This configuration element does not enable the scanning of any document types by itself.
Add to extractor configuration to enable recognizing the MRZ only, specifically for documents that are otherwise not supported.
Note that this may enable scanning of documents that were not enabled through the accepted document types.
*/
export class MrzFallbackConfiguration {
    /** @param source {@displayType `DeepPartial<MrzFallbackConfiguration>`} */
    constructor(source = {}) {
        this._type = 'MRZFallbackConfiguration';
        /**
          List of ISO 3166-1 alpha-3 country codes for which the MRZ fallback is enabled. (e.g. "DEU" for Germany).
          */
        this.acceptedCountries = [];
        /**
          List of MRZ document types for which MRZ fallback is enabled.
          */
        this.acceptedMRZTypes = [];
        if (source.acceptedCountries !== undefined) {
            this.acceptedCountries = source.acceptedCountries.map((it) => {
                return it;
            });
        }
        if (source.acceptedMRZTypes !== undefined) {
            this.acceptedMRZTypes = source.acceptedMRZTypes.map((it) => {
                return it;
            });
        }
    }
}
/**
Auto-focus configuration.
The recognizer will ignore frames that are not focused. This option is enabled by default.
This configuration has no effect in SINGLE_SHOT mode.
*/
export class AutoFocusConfiguration {
    /** @param source {@displayType `DeepPartial<AutoFocusConfiguration>`} */
    constructor(source = {}) {
        this._type = 'AutoFocusConfiguration';
        /**
          Sensitivity threshold for detecting that autofocus is in progress.
          The value should be in the range [0.0, 1.0].
          The lower the value, the more frames might be discarded as not focused.
          The higher the value, the earlier the focus might be considered as focused.
          If set to 0.0, the feature is disabled.
          
          Default is 0.02
          */
        this.sensitivityThreshold = 0.02;
        if (source.sensitivityThreshold !== undefined) {
            this.sensitivityThreshold = source.sensitivityThreshold;
        }
    }
}
/**
Glare detection configuration.
The recognizer will detect whether fields are obstructed by glare. This feature is enabled by default.
This configuration has no effect in SINGLE_SHOT mode.
*/
export class GlareDetectionConfiguration {
    /** @param source {@displayType `DeepPartial<GlareDetectionConfiguration>`} */
    constructor(source = {}) {
        this._type = 'GlareDetectionConfiguration';
        /**
          Glare detection threshold.
          The value should be in the range [0.0, 1.0].
          Determines how much glare is acceptable relative to the text size. So 0.5 means that the glare can be up to 50% of the text size.
          If set to 0.0, the feature is disabled.
          
          Default is 0.5
          */
        this.glareDetectionThreshold = 0.5;
        if (source.glareDetectionThreshold !== undefined) {
            this.glareDetectionThreshold = source.glareDetectionThreshold;
        }
    }
}
/**
Convenience configuration element for enabling the scanning of multiple document types with a common configuration.
Add to extractor configuration to enable the scanning of multiple document types.
*/
export class DocumentDataExtractorCommonConfiguration {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorCommonConfiguration>`} */
    constructor(source = {}) {
        this._type = 'DocumentDataExtractorCommonConfiguration';
        /**
          List of document types to scan. By default, the list is empty.
          */
        this.acceptedDocumentTypes = [
            'DeIdCardFront',
            'DeIdCardBack',
            'DeHealthInsuranceCardFront',
            'DePassport',
            'DeResidencePermitFront',
            'DeResidencePermitBack',
            'EuropeanHealthInsuranceCard',
            'EuropeanDriverLicenseFront',
            'EuropeanDriverLicenseBack',
        ];
        if (source.acceptedDocumentTypes !== undefined) {
            this.acceptedDocumentTypes = source.acceptedDocumentTypes.map((it) => {
                return it;
            });
        }
    }
}
//# sourceMappingURL=DocumentDataExtractorConfigurationTypes.js.map